var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 12.4003C12.5327 12.4003 11.966 12.6503 11.5327 13.042L5.59101 9.58366C5.63268 9.39199 5.66602 9.20033 5.66602 9.00033C5.66602 8.80033 5.63268 8.60866 5.59101 8.41699L11.466 4.99199C11.916 5.40866 12.5077 5.66699 13.166 5.66699C14.5467 5.66699 15.666 4.5477 15.666 3.16699C15.666 1.78628 14.5467 0.666992 13.166 0.666992C11.7853 0.666992 10.666 1.78628 10.666 3.16699C10.666 3.36699 10.6993 3.55866 10.741 3.75033L4.86601 7.17533C4.41602 6.75866 3.82435 6.50033 3.16602 6.50033C1.7853 6.50033 0.666016 7.61961 0.666016 9.00033C0.666016 10.381 1.7853 11.5003 3.16602 11.5003C3.82435 11.5003 4.41602 11.242 4.86601 10.8253L10.7993 14.2837C10.7577 14.4587 10.7327 14.642 10.7327 14.8337C10.7327 16.1753 11.8243 17.2587 13.166 17.2587C14.5077 17.2587 15.5993 16.1753 15.5993 14.8337C15.5993 13.4898 14.5099 12.4003 13.166 12.4003Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.ff5dbbf6.svg";
export { ForwardRef as ReactComponent };